import React from 'react';
import { Route, Redirect } from 'react-router-dom';


function SecureRoute({ component: Component, ...rest }) {
  const existingTokens = JSON.parse(localStorage.getItem("auth"));

  const chkAuthToken = () => {
    if (existingTokens) {
      if (existingTokens.expires_in > Date.now() / 1000) {
        return true;
      }
    }
    window.location.href = "/login";

    return false;
  };

  return (
    <Route
      {...rest}
      render={props =>
        chkAuthToken() ? <Component {...props} /> : <Redirect to={{ pathname: "/login", state: { referer: window.location.pathname } }} />
      }
    />
  );
}

export default SecureRoute;